import { z } from 'zod';

// Supplier contact names are optional; tesseract's features.supplierContactNamePolicy decides
// whether send-out needs them (BUG-2456 / BUG-2927). Blank input is sent as null so the
// REQUIRE_FULL gate (contact_first_name IS NOT NULL) stays strict for tenants on the default.
export const OptionalContactName = z
  .string()
  .nullable()
  .transform((value) => value?.trim() || null);
